module.exports = __webpack_public_path__ + "img/9788936442125.6d12a28e.jpg";